<template>
  <div id="app" class="site container hfeed" style="height: auto !important">
    <HeadNav selectedLanguage="en" page="privacy-policy" />

    <div id="content" class="main-wrapper" style="height: auto !important;">
<article>
<h1>Privacy Policy</h1>

<h2>1. Introduction</h2>
<p>This Privacy Policy explains how we collect, use, and protect your personal information when you visit our website. Your privacy is important to us, and we are committed to safeguarding your data.</p>

<h2>2. Information We Collect</h2>
<p>We may collect the following types of information:</p>
<ul>
<li><strong>Usage Data:</strong> Information about how you interact with our website, including pages visited, time spent, and click patterns.</li>
<li><strong>Device Information:</strong> Information about your device, including browser type, operating system, and IP address.</li>
<li><strong>Cookies:</strong> Small text files stored on your device to improve your browsing experience.</li>
</ul>

<h2>3. How We Use Your Information</h2>
<p>We use the collected information to:</p>
<ul>
<li>Improve our website and user experience</li>
<li>Analyze website traffic and usage patterns</li>
<li>Provide personalized content and recommendations</li>
<li>Ensure the security and integrity of our website</li>
</ul>

<h2>4. Third-Party Services</h2>
<p>We may use third-party services such as analytics tools and advertising networks that may collect information about your visit. These third parties have their own privacy policies, and we encourage you to review them.</p>

<h2>5. Data Security</h2>
<p>We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is completely secure.</p>

<h2>6. Your Rights</h2>
<p>You have the right to:</p>
<ul>
<li>Access the personal information we hold about you</li>
<li>Request correction of inaccurate information</li>
<li>Request deletion of your personal information</li>
<li>Opt out of certain data collection practices</li>
</ul>

<h2>7. Changes to This Policy</h2>
<p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.</p>

<h2>8. Contact Us</h2>
<p>If you have any questions about this Privacy Policy, please contact us through our website.</p>

<h2>Important Notice</h2>
<p><strong>Not affiliated with Meta:</strong> This website is not affiliated with WhatsApp or Meta Platforms, Inc. We do not have access to any WhatsApp user data or chat information.</p>
</article>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      pageName: 'privacy-policy',
      selectedLanguage: 'en',
    };
  },
  components: {
    HeadNav
  },
  methods: {
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
  },
};
</script>

<style lang="scss" scoped></style>